export default "__VITE_ASSET__CPJqDQgI__"